import { Check } from "lucide-react";

export default function Stepper({ steps, current }) {
  return (
    <div data-testid="stepper" className="mx-auto mb-8 flex max-w-3xl items-start">
      {steps.map((s, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <div key={s} className="relative flex flex-1 flex-col items-center">
            {i > 0 && <span className={`absolute right-1/2 top-4 h-0.5 w-full ${i <= current ? "bg-cr-gold" : "bg-cr-line"}`} />}
            <span data-testid={`step-${i + 1}${active ? "-active" : done ? "-done" : ""}`} className={`relative z-10 grid h-8 w-8 place-items-center rounded-full border text-sm font-bold ${done || active ? "border-cr-gold bg-cr-gold text-black" : "border-cr-muted bg-cr-bg text-cr-ink"}`}>
              {done ? <Check className="h-4 w-4" /> : i + 1}
            </span>
            <span className={`mt-2 text-center text-xs sm:text-sm ${active ? "font-semibold text-cr-ink" : "text-cr-ink/75"}`}>{s}</span>
          </div>
        );
      })}
    </div>
  );
}
